var _path;

import * as React from "react";

function SvgDesktop(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.333 5.778H6.667A2.667 2.667 0 004 8.444v16c0 1.5 1.167 2.667 2.667 2.667h26.666A2.667 2.667 0 0036 24.444v-16C36 7 34.778 5.778 33.333 5.778zM33 24.444H7c-.222 0-.333-.11-.333-.333V8.778c0-.167.11-.334.333-.334h26c.167 0 .333.167.333.334V24.11c0 .222-.166.333-.333.333zm-2.333 8.445c0-.722-.611-1.334-1.334-1.334h-5.5L22.778 28.5a.651.651 0 00-.611-.5h-4.39a.65.65 0 00-.61.5l-1.056 3.055h-5.444c-.778 0-1.334.612-1.334 1.334 0 .778.556 1.333 1.334 1.333h18.666c.723 0 1.334-.555 1.334-1.333z"
  })));
}

export default SvgDesktop;